'use strict';

module.exports = {
    LANG: 'th-th',
    SIGN: 'ลงชื่อ',
    REGISTER: 'การลงทะเบียน',
    QUICK_ACCESS: 'ควิกแอคเซสด้วย',
    SIGN_JOIN: 'ลงชื่อเข้าใจหรือสมัครฟรี!',
    NOT_MEMBER: 'ไม่ใช่สมาชิก?',
    ALREADY_MEMBER: 'เป็นสมาชิกของ AliExpress/Alibaba อยู่แล้ว?',
    SHOW_ALL: 'แสดงทั้งหมด',
    HIDE: 'ซ่อน'
};